<template>
  <div
    v-if="hydratedData !== null"
    class="zmm-gallery">
    <div class="zmm-gallery__arrows">
      <div
        class="zmm-gallery__arrows__prev"
        @click="$_swipeRight">
          <svg width="24px" height="29px" viewBox="0 0 24 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g class="svg-arrow" transform="translate(-1579.000000, -1803.000000)" stroke-width="2">
                      <path d="M1580,1804.77251 L1580,1830.22749 L1601.0662,1817.5 L1580,1804.77251 Z" id="Rectangle-Copy" transform="translate(1591.000000, 1817.500000) scale(-1, 1) translate(-1591.000000, -1817.500000) "></path>
                  </g>
              </g>
          </svg>
      </div>
      <div
        class="zmm-gallery__arrows__next"
        @click="$_swipeLeft">
          <svg width="24px" height="29px" viewBox="0 0 24 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g class="svg-arrow" transform="translate(-1628.000000, -1803.000000)" stroke-width="2">
                    <path d="M1629,1804.77251 L1629,1830.22749 L1650.0662,1817.5 L1629,1804.77251 Z" id="Rectangle"></path>
                </g>
            </g>
          </svg>
      </div>
    </div>
    <div
      v-slider-swipe="{ left: $_swipeLeft, right: $_swipeRight }"
      v-slider="{ onClick: $_onElementClick }"
      ref="elements"
      class="zmm-gallery__slides">
      <picture
        v-for="(slide, index) of hydratedData"
        @click="_zoom(imgServer + slide['zoom-desktop'], imgServer + slide['zoom-portrait'])"
        class="zmm-gallery__slides__slide"
        :class="{'zmm-gallery__slides__slide--noTouch': !touch}"
        draggable="false"
        :key="index">
          <source :srcset="imgServer + slide['image-listing']" media="(min-width: 1000px)">
          <img draggable="false" :src="imgServer + slide['image-listing']" :alt="slide.alt">
      </picture>
    </div>
    <div
      :style="{ backgroundImage: zoomImage }"
      :class="{ 'velinaUp': velinaOpen }"
      class="zmm-gallery__velina-zoom">
        <div
          class="overlay-back"
          @click="_zoomOut">
            {{ $t('overlayBack') }}
        </div>
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    ended: false,
    currentSlide: 0,
    elementsCount: 0,
    swiping: false,
    velinaOpen: false,
    currentZoomImage: ''
  }),
  props: {
    galleryId: {
      type: String,
      default: () => '0'
    },
    lang: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'pictureGallery',
      'touch'
    ]),
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    pictureGalleryApiInput: {
      get () {
        return {
          lang: this.lang,
          id: this.galleryId
        }
      }
    },
    hydratedData: {
      get () {
        return this.pictureGallery({
          lang: this.lang,
          id: this.galleryId
        }) || null
      }
    },
    zoomImage: {
      get () {
        return `url(${this.currentZoomImage})`
      }
    }
  },
  methods: {
    ...mapActions([
      'loadPictureGallery'
    ]),
    $_onElementClick (element, elementsCount, index, scroll = true) {
      if (this.swiping) return
      this.$_scrollTo(element, elementsCount, index, scroll)
    },
    $_scrollTo (element, elementsCount, index, scroll = true) {
      this.currentSlide = index
      this.elementsCount = elementsCount

      if (!scroll) return
      const parentNode = element.parentNode
      parentNode.scrollTo({
        top: 0,
        left: element.offsetLeft - (parentNode.offsetWidth / 2 - element.offsetWidth / 2),
        behavior: 'smooth'
      })
    },
    $_swipeLeft () {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide + 1]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide + 1)
    },
    $_swipeRight () {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide - 1]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide - 1)
    },
    _zoom (img, imgPortrait) {
      if (window.innerWidth > window.innerHeight) { this.currentZoomImage = img } else this.currentZoomImage = imgPortrait
      if (window.innerWidth > window.innerHeight) this.velinaOpen = true
    },
    _zoomOut () {
      this.velinaOpen = false
    }
  },
  watch: {
    pictureGalleryApiInput: {
      handler (input) {
        this.loadPictureGallery(input)
      },
      deep: true,
      immediate: true
    }
  },
  directives: {
    slider: {
      bind (el, binding) {
        const elements = Array.prototype.slice.call(el.children)
        _.forEach(elements, (element, key) => { element.addEventListener('click', binding.value.onClick.bind(undefined, element, elements.length, key)) })
        binding.value.onClick(elements[0], elements.length, 0, false)
      },
      unbind (el, binding) {
        const elements = Array.prototype.slice.call(el.children)
        _.forEach(elements, (element, key) => { element.removeEventListener('click', binding.value.onClick.bind(undefined, element, elements.length, key)) })
      }
    },
    'slider-swipe': {
      bind (el, binding) {
        const manager = new Hammer.Manager(el)
        const swipe = new Hammer.Swipe()
        manager.add(swipe)
        manager.on('swipeleft', binding.value.left)
        manager.on('swiperight', binding.value.right)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";

.zmm-gallery {
  width: 100%;
  padding: 2rem 0;
}

.zmm-gallery__slides {
  white-space: nowrap;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;

  padding-left: 10px;

  @media #{$large_mq} {
    padding-left: calc((100vw - 750px + 21px)/2);
  }
  @media #{$xlarge_mq} {
    padding-left: calc((100vw - 850px + 21px)/2);
  }
  @media #{$xxlarge_mq} {
    padding-left: calc((100vw - 950px + 21px)/2);
  }

  img{
    width: 100%;
    height: auto;
  }
}

.zmm-gallery__slides__slide {
  display: inline-block;
  width: 100%;

  @media #{$medium_mq} {

    width: auto;
    margin-right: 2.5%;
    margin-left: 2.5%;

    &:first-child {
        margin-left: 0;
    }
  }
}

.zmm-gallery__slides__slide.zmm-gallery__slides__slide--noTouch::before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
  background-color: rgba(103, 145, 150, 0.6);

  transition: opacity 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.zmm-gallery__slides__slide.zmm-gallery__slides__slide--noTouch:hover::before{
  opacity: 1;
}

.zmm-gallery__counter__dot--active {
  background-color: gray;
}

.zmm-gallery__arrows {
  padding: 2rem 0 4rem;
  text-align: right;
  margin-right: 2rem;

  div {
    display: inline-block;
    margin-left: 1.5rem;
    cursor: pointer;

    svg {
      width: 24px;
      height: 29px;
    }
  }
}

.zmm-gallery__arrows__prev .svg-arrow{
  stroke: #EFEFF1;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
}
.zmm-gallery__arrows__next .svg-arrow{
  stroke: #4A4A4A;
  transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.zmm-gallery__arrows__prev:hover .svg-arrow{
  stroke: #679196;
}
.zmm-gallery__arrows__next:hover .svg-arrow{
  stroke: #679196;
}

.zmm-gallery__velina-zoom{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: .9);
  transform: translate3d(0, 100%, 0);

  background-position: center center;
  background-size: cover;

  transition: transform 400ms cubic-bezier(0.23, 1, 0.32, 1);
  z-index: 200;

  .hamburger-menu-container::before{
    top: 46%;
    left: 44%;
  }

  .hamburger-menu, .hamburger-menu::after, .hamburger-menu::before{
    height: 1px;
    width: 30px;
  }

}

.zmm-gallery__velina-zoom.velinaUp{
  transform: translate3d(0, 0, 0);
}

</style>
